import * as React from 'react'
import Box from '@mui/material/Box'

export default function FullPageBackdrop({children, ...props}){
  return <Box
    {...props}
    sx={{
      zIndex: 2100,
      backgroundColor: '#111119',
      minWidth: '100vw',
      minHeight: '100vh',
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      right: 0,
      bottom: 0,
      top: 0,
      left: 0,
      WebkitTapHighlightColor: 'transparent',
      WebkitTransition: 'none',
      transition: 'none',
      ...props.sx
    }}
  >
    {children}
  </Box>
}
